var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card card-custom"},[_c('div',{staticClass:"card-body"},[_c('v-server-table',{ref:"table",class:'dataTable table-row-dashed',attrs:{"columns":_vm.columns,"options":_vm.options}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }